var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isScheduled || _vm.$store.state.isAdminView
    ? _c(
        "div",
        {
          staticClass: "menu--item",
          class: _vm.containerClasses,
          attrs: {
            "data-menu-item-id": _vm.item.mi_id,
            id: "menu--item-" + _vm.item.mi_id,
          },
        },
        [
          "" === _vm.tagLocation
            ? _vm._l(_vm.item.tags, function (tag) {
                return _c("menu-tag", {
                  key: tag.mt_id,
                  attrs: { tag: tag, "menu-type": "visual" },
                })
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showBin
            ? _c(
                "span",
                {
                  staticClass: "menu--item_bin",
                  attrs: { "aria-label": "bin " + _vm.getItemBIN(_vm.item) },
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v(_vm._s(_vm.getItemBIN(_vm.item))),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "h3",
            { staticClass: "menu--item_title" },
            [
              "before-title" === _vm.tagLocation
                ? _vm._l(_vm.item.tags, function (tag) {
                    return _c("menu-tag", {
                      key: tag.mt_id,
                      attrs: { tag: tag, "menu-type": "visual" },
                    })
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.showBin
                      ? _vm.removeBINFromTitle(_vm.item)
                      : _vm.item.mi_title
                  ),
                },
              }),
              _vm._v(" "),
              "after-title" === _vm.tagLocation
                ? _vm._l(_vm.item.tags, function (tag) {
                    return _c("menu-tag", {
                      key: tag.mt_id,
                      attrs: { tag: tag, "menu-type": "visual" },
                    })
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.item.mi_subtitle.length
                ? _c("span", {
                    staticClass: "menu--item_subtitle",
                    domProps: { innerHTML: _vm._s(_vm.item.mi_subtitle) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.layout === "price-inline" &&
              _vm.item.price_display.length &&
              !_vm.pricingTypes.length
                ? _c("menu-item-price", {
                    attrs: {
                      "price-to-display": _vm.priceToDisplay,
                      "price-label": _vm.item.price_label,
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.$store.state.isAdminView && _vm.item.normalizedSchedules.length
            ? _c("menu-schedules", {
                attrs: { "normalized-schedules": _vm.item.normalizedSchedules },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.item.mi_description.length
            ? _c("div", {
                staticClass: "menu--item_description",
                domProps: { innerHTML: _vm._s(_vm.item.mi_description) },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.pricingTypes.length
            ? _vm._l(
                _vm.pricingTypesToDisplay,
                function (pricingTypeData, pricingType) {
                  return _c("menu-item-price", {
                    key: pricingType,
                    attrs: {
                      "price-to-display": pricingTypeData.price,
                      "aria-prefix": pricingType,
                      "price-label": pricingTypeData.label || "",
                    },
                  })
                }
              )
            : _vm.layout !== "price-inline" &&
              _vm.priceToDisplay.length &&
              !_vm.isGroupedByPrice
            ? _c("menu-item-price", {
                attrs: {
                  "price-to-display": _vm.priceToDisplay,
                  "price-label": _vm.item.price_label,
                },
              })
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }